import { render, staticRenderFns } from "./acusitem.vue?vue&type=template&id=06ca95c6&scoped=true&"
import script from "./acusitem.vue?vue&type=script&lang=js&"
export * from "./acusitem.vue?vue&type=script&lang=js&"
import style0 from "./acusitem.vue?vue&type=style&index=0&id=06ca95c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca95c6",
  null
  
)

export default component.exports